export const CONSULTOR = { name: "Leomar Ramos", first: "Leomar", years: "6" };
export const WHATSAPP_DISPLAY = "(61) 99909-9383";
export const INSTAGRAM_HANDLE = "@corretor_leomar";
export const INSTAGRAM_URL = "https://instagram.com/corretor_leomar";
export const EMAIL = "comercial.leomarramos@gmail.com";
export const waLink = (msg) =>
  `https://wa.me/5561999099383?text=${encodeURIComponent(msg)}`;
export const WA_DEFAULT = waLink(
  "Olá! Gostaria de receber uma cotação personalizada de plano de saúde."
);

export const NAV_LINKS = [
  { label: "O consultor", href: "#sobre" },
  { label: "Planos", href: "#planos" },
  { label: "Operadoras", href: "#operadoras" },
  { label: "Empresas", href: "#empresas" },
  { label: "Depoimentos", href: "#depoimentos" },
];

export const MARQUEE_ITEMS = [
  "Pessoa Física",
  "Adesão",
  "Empresarial / PME",
  "Planos Odontológicos",
  "Planos para Crianças",
  "Terceira Idade",
  "Regulamentados pela ANS",
  "Atendimento Presencial ou Virtual",
];

export const SOLUTIONS = [
  {
    id: "individual",
    icon: "User",
    title: "Plano Individual / Familiar",
    text: "Opções para quem busca um plano de saúde para si ou para seus dependentes, com análise de rede, faixa de preço e perfil de uso.",
    tag: "PF e dependentes",
  },
  {
    id: "adesao",
    icon: "Users",
    title: "Plano por Adesão",
    text: "Opções para pessoas elegíveis às modalidades de adesão, com condições diferenciadas conforme a entidade e o perfil.",
    tag: "Elegibilidade por perfil",
  },
  {
    id: "empresarial",
    icon: "Building2",
    title: "Plano Empresarial",
    text: "Planos para pequenas, médias e grandes empresas — de 2 vidas até operações com mais de 99 vidas.",
    tag: "A partir de 2 vidas",
  },
];

export const OPERATORS_NATIONAL = [
  { name: "Bradesco Saúde", color: "#CC092F", logo: "/assets/logos/bradesco.png" },
  { name: "SulAmérica", color: "#003A70", logo: "/assets/logos/sulamerica.png" },
  { name: "Porto Saúde", color: "#0069B4", sub: "Porto Seguro", logo: "/assets/logos/porto-saude.png", dark: true },
  { name: "Seguros Unimed", color: "#00995D", logo: "/assets/logos/seguros-unimed.png", tall: true, tile: true },
  { name: "Amil", color: "#5E1FE8", logo: "/assets/logos/amil.png" },
  { name: "NotreDame Intermédica", color: "#F5A300", logo: "/assets/logos/notredame.png" },
  { name: "Omint Saúde", color: "#1B3A6B", logo: "/assets/logos/omint.png" },
  { name: "MedSênior", color: "#6DBE45", logo: "/assets/logos/medsenior.png" },
];

export const OPERATORS_REGIONAL = [
  { name: "Amil Regional", color: "#5E1FE8", logo: "/assets/logos/amil.png", sub: "Regional" },
  { name: "Seguros Unimed Regional", color: "#00995D", logo: "/assets/logos/seguros-unimed.png", tall: true, tile: true, sub: "Regional" },
  { name: "Plenum Saúde", color: "#3E7C4F", logo: "/assets/logos/plenum.png" },
  { name: "Unity Saúde", color: "#39465E", logo: "/assets/logos/unity.png", tile: true, tall: true },
  { name: "Quallity Saúde", color: "#DE0D17", logo: "/assets/logos/quallity.png", tile: true, tall: true },
  { name: "Proasa", color: "#2B5EA7", logo: "/assets/logos/proasa.png" },
  { name: "Evo Saúde", color: "#E59AA0", logo: "/assets/logos/evo.png" },
  { name: "Hapvida", color: "#2E7BD1", logo: "/assets/logos/hapvida.png" },
  { name: "MedSênior", color: "#6DBE45", logo: "/assets/logos/medsenior.png" },
];

export const DENTAL = [
  { name: "Bradesco Dental", color: "#CC092F" },
  { name: "SulAmérica Odonto", color: "#F7941E" },
  { name: "Amil Dental", color: "#5E1FE8" },
  { name: "OdontoGroup", color: "#A8B3C2" },
];

export const DIFFERENTIALS = [
  {
    n: "01",
    title: "Atendimento personalizado",
    text: "Cada análise começa entendendo o seu momento, sua rotina e o que realmente importa para você.",
  },
  {
    n: "02",
    title: "Análise de diferentes operadoras",
    text: "Comparo opções de diversas operadoras, nacionais e regionais, sem vínculo com uma única marca.",
  },
  {
    n: "03",
    title: "Comparação de opções disponíveis",
    text: "Você recebe as alternativas lado a lado, com clareza sobre rede, modalidade e faixa de preço.",
  },
  {
    n: "04",
    title: "Orientação durante a contratação",
    text: "Acompanho cada etapa da contratação para que tudo seja simples, transparente e sem surpresas.",
  },
  {
    n: "05",
    title: "Suporte antes, durante e após",
    text: "O relacionamento não termina na assinatura: sigo disponível para dúvidas, ajustes e reavaliações.",
  },
  {
    n: "06",
    title: "Pessoas físicas e empresas",
    text: "Atendo desde planos individuais até operações empresariais com mais de 99 vidas.",
  },
];

export const PROCESS_STEPS = [
  { n: "1", title: "Entenda seu perfil", text: "Conheço as necessidades e prioridades da sua empresa." },
  { n: "2", title: "Analise as opções", text: "Seleciono alternativas compatíveis com o seu perfil." },
  { n: "3", title: "Compare as condições", text: "Compare rede, cobertura, valores e benefícios." },
  { n: "4", title: "Escolha seu plano", text: "Contratação orientada e suporte do início ao fim." },
];

export const BUSINESS_SIZES = [
  { k: "Pequenas Empresas", text: "Planos empresariais para empresas de pequeno porte" },
  { k: "3+ Vidas", text: "Planos empresariais a partir de 3 vidas" },
  { k: "30+ Vidas", text: "Condições diferenciadas para empresas maiores" },
];

export const BUSINESS_BENEFITS = [
  { text: "Melhor custo-benefício", highlight: true },
  { text: "Rede credenciada mais ampla" },
  { text: "Opção de incluir odontológico" },
  { text: "Atendimento em nível nacional" },
  { text: "Maior variedade de profissionais e serviços de saúde" },
  { text: "Opções de planos adequadas ao perfil da empresa" },
];

export const TESTIMONIALS_REAL = [
  {
    name: "Amanda",
    text: "Fui muito bem atendida durante todo o processo. O atendimento foi claro, rápido e me ajudou a encontrar uma opção que realmente fazia sentido para mim.",
    avatar: "/assets/avatars/02.png",
  },
  {
    name: "Giovanna",
    text: "Gostei muito da atenção e da forma como todas as opções foram explicadas. Tive segurança para escolher o plano que melhor atendia às minhas necessidades.",
    avatar: "/assets/avatars/04.png",
  },
  {
    name: "Geovana Abraão",
    text: "O atendimento foi excelente do início ao fim. Recebi várias opções e consegui escolher um plano com uma rede muito boa e dentro do que eu procurava.",
    avatar: "/assets/avatars/06.png",
  },
  {
    name: "Thais",
    text: "Fiquei muito satisfeita com o atendimento. Tudo foi explicado de forma simples e tive suporte em todas as etapas da contratação.",
    avatar: "/assets/avatars/08.png",
  },
  {
    name: "Vanessa Camargo",
    text: "Consegui encontrar uma opção muito melhor do que eu imaginava. O atendimento foi personalizado e fez toda a diferença na minha escolha.",
    avatar: "/assets/avatars/10.png",
  },
  {
    name: "Edilene Abreu",
    text: "Gostei muito da consultoria e da atenção recebida. Tive ajuda para comparar as opções e escolher um plano adequado às minhas necessidades.",
    avatar: "/assets/avatars/12.png",
  },
  {
    name: "Darlene",
    text: "Excelente atendimento! Recebi todas as informações que precisava e fui acompanhada durante todo o processo de contratação.",
    avatar: "/assets/avatars/14.png",
  },
];

export const TESTIMONIALS_ROW2 = [
  {
    name: "Marcos Vinícius Almeida",
    text: "Fui presencialmente à corretora e tive um excelente atendimento com o Leomar. Ele explicou todas as opções com muita clareza e me ajudou a escolher um plano que realmente valeu a pena.",
    avatar: "/assets/avatars/01.png",
  },
  {
    name: "Felipe Augusto Rocha",
    text: "Gostei muito do plano que conseguimos. A rede credenciada é excelente e o atendimento do Leomar fez toda a diferença na hora de comparar as opções.",
    avatar: "/assets/avatars/03.png",
  },
  {
    name: "Ricardo Henrique Martins",
    text: "O Leomar foi muito atencioso desde o primeiro contato. Conseguiu encontrar uma opção com uma ótima rede e um valor que ficou dentro do que eu procurava.",
    avatar: "/assets/avatars/07.png",
  },
  {
    name: "André Luiz Carvalho",
    text: "Fui muito bem atendido e tive todas as minhas dúvidas esclarecidas. O plano escolhido me surpreendeu pela qualidade da cobertura e pela rede de atendimento.",
    avatar: "/assets/avatars/05.png",
  },
  {
    name: "Juliana Mendes Ferreira",
    text: "Adorei o atendimento do Leomar. Ele apresentou as opções de forma muito clara e me ajudou a encontrar um plano que atende muito bem ao que eu precisava.",
    avatar: "/assets/avatars/15.png",
  },
  {
    name: "Camila Rodrigues Santos",
    text: "Fiquei muito satisfeita com o plano e principalmente com todo o suporte durante a contratação. O Leomar acompanhou tudo de perto e tornou o processo muito tranquilo.",
    avatar: "/assets/avatars/16.png",
  },
];
